import { IconExternalLink } from '@tabler/icons-react';

export function ExternalLink({ children, href }: { children: React.ReactNode; href: string }) {
  return (
    <a target="_blank" href={href}>
      {children}
      <IconExternalLink style={{ transform: 'translateY(3px)', paddingLeft: '2px' }} width={16} height={18} />
    </a>
  );
}
